import styled from "styled-components/macro";
import LinkIcon from "@material-ui/icons/Link";

export const SvgLinkIcon = styled(LinkIcon)`
  font-size: 3.5rem;
  color: ${(props) => props.theme.palette.formSuccess};
`;
